const initailState = {
  gstVerificationData: {},
  gstLoading: false,
};

export function gstVerificationReducer(state = initailState, { type, payload }) {
  switch (type) {
    case "SHOW_GST_VERIFICATION":
      return { ...state, gstLoading: true, gstVerificationData: {} };
    case "GET_GST_DATA":
      return { ...state, gstVerificationData: payload ,gstLoading:false};
      case "CANNOT_GET_GST_DATA":
      return { ...state, gstLoading: false, gstVerificationData: {} };
      case "UPDATE_GST_DATA":
      return { ...state, gstLoading: false,  };

    default:
      return state;
  }
}
